jQuery(function ( $ ) {

	jQuery('li[data-target]', '.bp_formulare-leistungen').on('click', function ( evt ) {
		let el = jQuery(this),
			target = '#form-' + el.data('target');

		jQuery('li[data-target]', '.bp_formulare-leistungen').toggleClass('is-active', false);
		el.toggleClass('is-active', true);

		jQuery('.bp_formulare-inhalt > div').hide();
		jQuery(target).show();
	});
	jQuery('li[data-target]', '.bp_formulare-leistungen').first().trigger('click');


	jQuery('.filter a', '.bp_formulare--alphabetisch').each(( idx, item ) => {
		let href = jQuery(item).attr('href');
// console.log( item) ;
		if ( jQuery(href).length === 0 ) jQuery(item).attr('disabled', true);
	});


	jQuery('a[data-action="ajax"]', '.bp_formulare--alphabetisch').on('click', ( evt ) => {
		evt.preventDefault();

		let el = jQuery(evt.currentTarget);
		if( el.hasClass( 'is-loaded' ) ) {
			jQuery('.bp_formulare-inhalt', el.parent()).toggle();
			el.toggleClass('is-open');
			return;
		}
		el.addClass( 'is-loading' );
		jQuery('.bp_formulare-inhalt', el.parent()).remove();

		jQuery.ajax(c3AJAX.url, {
			method: 'post',
			data: {
				action: c3AJAX.action,
				href: el.attr('href'),
				type: el.data('type'),
				id: el.data('id')
			}
		}).then(( response ) => {
			el.addClass('is-loaded').removeClass('is-loading');
			let block = jQuery('<div class="bp_formulare-inhalt">').html(response);
			block.insertAfter(el).hide();
			jQuery('.collapse', block).collapse();
			block.show( );
			el.toggleClass('is-open', true);
		});
	});
});


